import { render, staticRenderFns } from "./NewsItemFooter.vue?vue&type=template&id=d1a3e48e&"
import script from "./NewsItemFooter.vue?vue&type=script&lang=js&"
export * from "./NewsItemFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports